import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import lock from '../../assets/lock.png'

function Navigation({ auth }) {
  const { admin } = auth
  const userName =
    admin.email.split('@')[0].split('.')[0].substring(0, 1) +
    '' +
    admin.email.split('@')[0].split('.')[1].substring(0, 1)

  return (
    <nav className='navbar'>
      <div className='side-nav'>
        <div className='user-profile d-flex flex-column justify-content-center align-items-center'>
          <div className='initials my-2 d-flex flex-column justify-content-center align-items-center'>
            <span>{userName}</span>
          </div>
          <div className='admin-email'>{admin.email}</div>
          <div className='text-light'>Administrator</div>
        </div>
        <ul className='navbar-nav mt-2 ms-auto'>
          <li className='nav-item '>
            <NavLink className='nav-link px-2' exact to='/'>
              <span className='ms-2'>
                <i className='fas fa-plus me-2'></i>
                Create Badge
              </span>
            </NavLink>
          </li>
          <li className='nav-item  mt-3'>
            <NavLink
              className='nav-link px-2'
              exact
              to={{
                pathname: '/issue',
                state: {
                  badgeName: '',
                },
              }}>
              <span className='ms-2'>
                <i className='fas fa-upload me-2'></i>Issue Badge
              </span>
            </NavLink>
          </li>
          <li className='nav-item  mt-3'>
            <NavLink className='nav-link px-2' exact to='/all-badges'>
              <span className='ms-2'>
                <i className='fas fa-user me-2'></i>All Badges
              </span>
            </NavLink>
          </li>
        </ul>
        <div className='sidebar-bottom-info container-fluid'>
          <div className='d-flex justify-content-between py-3 align-items-center'>
            <div className='lock col-md-2 d-flex justify-content-center align-items-center'>
              <img src={lock} alt='' />
            </div>
            <div className='col-md-8 me-2'>
              Encrypted End-to-End With <b className='text-right'>Blockchain</b>
              <br />
              <small>Employee information is secure</small>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

const mapStateToProps = ({ auth }) => ({ auth })
export default connect(mapStateToProps)(Navigation)
